import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShimmerButton } from "react-shimmer-effects";
import stacker from '../images/stackers.png';
import timer from '../images/timer.png';
import satsImg from '../images/sats.png';
import TopFive from './topFive';
// import * as APIHelper from '../Helper/mockAPIFetch';
import Icon from '../images/popupIcon.png'; 
import * as APIHelper from '../Helper/apiFetch';
import { useTimerHook } from '../hooks/timerHook';
import JackpotRewards from './jackpotRewards';
// import Notify from './notify';


/* const shimmer = [
    {
        rows: 1,
        width: 80,
        width2: 50,
        width3: 80
    },
    {
        rows: 1,
        width: 60,
        width2: 70,
        width3: 80
    },
    {
        rows: 1,
        width: 80,
        width2: 50,
        width3: 60
    },
    {
        rows: 1,
        width: 100,
        width2: 40,
        width3: 40
    },
    {
        rows: 1,
        width: 30,
        width2: 40,
        width3: 80
    }
] */
const shimmer = [
    {
        rows: 1,
        width: '100%',
        height: 60,
        width2: '100%',
        height2: 50,
        rows2: 1,
        width3: 120,
        height3: 105,
        height4: 20,
        width4: '100%'
    }
]

var jackpotData = [
    {
        jackpotImg: 'https://assets.gosats.io/notification/2023/3/1679568719223',
        weekNo: 'Week 1',
        date: '30th Oct - 5th Nov'
    },
    {
        jackpotImg: 'https://assets.gosats.io/notification/2023/3/1679568719223',
        weekNo: 'Week 2',
        date: '30th Oct - 5th Nov'
    },
    {
        jackpotImg: 'https://assets.gosats.io/notification/2023/3/1679568719223',
        weekNo: 'Week 3',
        date: '30th Oct - 5th Nov'
    },
    {
        jackpotImg: 'https://assets.gosats.io/notification/2023/3/1679568719223',
        weekNo: 'Week 4',
        date: '30th Oct - 5th Nov'
    }
]

const initiaData = require('./urlEncodeTest.json')

const TopStackers = () => {
    const [top5Data, setTop5Data] = useState();
    const [position, setPosition] = useState(initiaData?.topStacker.positionData);
    const [loader, setLoader] = useState(false);
    const [cardLoader, setCardLoader] = useState(true);
    const [prizes, setPrizes] = useState([]);
    const navigate = useNavigate();
    const formattedTimer = useTimerHook();

   /*  useEffect(() => {
        setCardLoader(true);
        APIHelper.prevWinners().then(resp => {
            if (resp.error) {
                navigate('/error');
            }
            setCardLoader(false);
            console.log(resp.prevWinners);
            sethof(resp.prevWinners);
        })
    }, []) */

    // const hofMapped = [...hof].reverse();

    useEffect(() => {
        setLoader(true);
        APIHelper.topFive().then(resData => {
            console.log(resData)
            if (!resData.error) {
                if (resData.topFive) setTop5Data(resData.topFive);
                if (resData.user) setPosition({ sats: resData.user });
                setPrizes(resData.prizes);
            } else {
                navigate('/error')
            }
            setLoader(false);
        })
    }, [])

    const shimerLoader = () => {
        return (shimmer?.map((data, index) => {
            return (
                <div style={{ height: '150px', width: 'auto', padding: '0px'}} className="matchContainer" key={index}>
                    <div className="shimmer-effect">
                    </div>
                </div>
            )
        }
        ))
    }

    return (
        <div className='stackerContainer'>
            <div>
                {
                    loader ?
                    <div style={{paddingTop: '20px'}}>
                    {shimerLoader()}
                    </div>
                        :
                        <div>
                            <JackpotRewards jackpotData = {prizes}/>  
                        </div>
                }

            </div>
            <div style={{margin: '20px'}}>
                <div className='topStackers-container'>
                    {/* <img className='stacker-img' src={stacker} alt=' ' /> */}
                    <div className='topStackers-title'>Highest Stacker Kaun Winners</div>
                    {/* <div className='topStackers-subtitle'>The top 3 stackers for next 3 days get exciting, surprise rewards.</div> */}
                    <div>
                        {
                            loader ?
                                <div>
                                    <div style={{ paddingTop: '20px' }}>
                                        {shimerLoader()}
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className='d-flex postion-container'>
                                        <div className='d-flex'>
                                            <span className='position-title'>Your Stacked Sats </span>
                                        </div>
                                        <span className='sats'><img className='sastImg mb-1' src={satsImg} alt=' ' />{position?.sats}</span>
                                    </div>
                                    <div>
                                        {
                                            top5Data && top5Data.slice(0, 3).map((obj, index) => {
                                                return <TopFive key={index} userData={obj} rank={index + 1} />
                                            })
                                        }
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopStackers;


